<template>
  <div id="parentx-demo-2">
    <meta-message-template-pop-up
        :instance="instance"
        :closeCallback="closeCallback"
        :opened="openedMessageTemplatePopUp"
        :to-number="activeChat ? activeChat.customer.phone_number : ''"
        :customer-name="activeChat ? activeChat.customer.name : ''"
        @on-success="selectActiveChat(null, true)"
    />

    <chosen-instance-pop-up
        :is-read-only="true"
        :is-active="activeChosen"
        :is-multiple="activeMultiple"
        :only-allowed="!activeMultiple"
        :is-allowed-not-select="activeMultiple"
        :active-instances="activeMultiple ? chosenInstances : null"
        :title="activeMultiple ? 'Filtrar por conexão' : 'Selecionar Conexão'"
        @close="closeChosen"
        @chosen-instances="selected"
    />

    <vs-sidebar
        parent="#chat-app"
        :position-right="false"
        :hidden-background="false"
        v-model="active"
        id="new-chat-sidebar"
        class="items-no-padding"
    >
      <div class="header-sidebar p-0" slot="header">
        <div class="flex items-center justify-center">
          <h3 class="text-primary px-4">Iniciar Conversa</h3>
          <feather-icon
              icon="XIcon"
              svgClasses="cursor-pointer"
              @click="closeNewChat"
          ></feather-icon>
        </div>

        <div class="flex items-center justify-center mt-3">
          <vs-input
              icon-no-border
              icon="icon-search"
              icon-pack="feather"
              class="input-rounded-full"
              placeholder="Busque o nome ou número do contato"
              style="flex: 1;"
              v-model="searchQuery"
              @change="searchBlank"
              @keydown.enter.prevent="onEnterSearch"
          />

          <vx-tooltip class="ml-3 text-right" :text="instanceIds.length > 0 ? 'Ativado o filtro por conexão' : 'Filtrar por conexão'" v-if="unifyConnections">
            <vs-button
              v-if="unifyConnections"
              @click="chooseMutilpe"
              icon="icon-sliders"
              icon-pack="feather"
              color="primary"
              :type="instanceIds.length > 0 ? 'filled' : 'border'"
            />
          </vx-tooltip>

          <vs-button
            @click="searchCustomer"
            icon="search"
            class="ml-3 py-2 px-5"
          />
        </div>
      </div>

      <VuePerfectScrollbar
          class="chat-scroll-area"
          :settings="settings"
          :key="$vs.rtl"
          @ps-y-reach-end="newChatScrollHandler"
          ref="newChatScroll"
      >
        <!-- ACTIVE CHATS LIST -->
        <div class="chat__chats-list">
          <ul class="chat__active-chats bordered-items">
            <li
                class="cursor-pointer"
                v-for="customer in customers"
                :key="`chat-customer-${customer.customer.id}`"
                @click="updateActiveChatUser(customer)"
            >
              <chat-contact
                  :showPhoneNumber="true"
                  :contact="customer"
                  :last-message="null"
                  :unseenMsg="0"
                  :isActiveChatUser="false"
              />
            </li>
            <li v-show="searchingForCustomers">
              <div
                  id="new-chat-loading-customers"
                  class="vs-con-loading__container"
                  style="height: 120px;"
              ></div>
            </li>
          </ul>
        </div>
      </VuePerfectScrollbar>
    </vs-sidebar>
  </div>
</template>

<script>
import ChatContact from "./ChatContact.vue"
import customerApi from '@/http/requests/customer'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {ChatTicketService} from "@/db/chatTicket_service";
import {CustomerService} from "@/db/customer_service";
import MetaMessageTemplatePopUp from "./MetaMessageTemplatePopUp";
import ChosenInstancePopUp from "../instances/ChosenInstancePopUp.vue";

export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      limitPerPage: 10,
      instanceIds: [],
      activeChat: null,
      lastPage: false,
      reopenChat: false,
      activeChosen: false,
      activeMultiple: false,
      searchingForCustomers: false,
      openedMessageTemplatePopUp: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      }
    }
  },
  computed: {
    chatContacts() {
      return this.$store.state.chatContact ? this.$store.state.chatContact.chatContacts : []
    },
    customers() {
      const customers = JSON.parse(JSON.stringify(
          this.$store.state.customer && this.$store.state.customer.customers.items
              ? this.$store.state.customer.customers.items
              : []
      ))

      for (const chatContact of this.chatContacts) {
        const customerBaseIndex = customers.findIndex((c) => c.id === chatContact.id)
        if (customerBaseIndex >= 0) {
          Object.assign(customers[customerBaseIndex], chatContact)
        }
      }

      const chatContacts = [];

      for (const customer of customers) {
        chatContacts.push({customer});
      }

      return chatContacts
    },
    setting() {
      return this.$store.state.settings.settings.limit_chat_tickets;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    limitChatTicketsActivated() {
      return this.$store.state.settings.settings.limit_chat_tickets_activated;
    },
    unifyConnections() {
      return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
    },
    instance(){
      const chosenInstances = this.$store.state.instance.chosenInstances;
      const chosen = chosenInstances.filter(instance => this.instanceIds.includes(instance.id))
      return chosen.length > 0 ? chosen[0] : chosenInstances[0]
    },
    chosenInstances(){
      return this.$store.state.instance.instances.filter(instance => this.instanceIds.includes(instance.id))
    },
    searchFilted(){
      if (!this.searchQuery){ return ''; }

      const hasEmoji = this.searchQuery.match(/[^\p{L}\x00-\x7F]+/u);
      let cleaned = this.searchQuery.replace(/[^a-zA-Z0-9\sÀ-ÿ\-\/]/g, '');
      if (hasEmoji && hasEmoji[0]){ cleaned += hasEmoji[0] }

      return cleaned
    }
  },
  watch: {
    active: function (isActive) {
      if (isActive) {
        this.cleanData(true);
        this.$store.dispatch("customer/fetch", {
          deleted_at: null,
          pagination_page: this.currentPage,
          pagination_limit: this.limitPerPage
        })
      } else {
        this.closeNewChat();
      }
    },
    searchingForCustomers(val) {
      if (val) {
        this.$vs.loading({
          container: `#new-chat-loading-customers`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close("#new-chat-loading-customers > .con-vs-loading")
      }
    }
  },
  methods: {
    newChatScrollHandler() {
      const scrollTop = this.$refs.newChatScroll.$el.scrollTop

      if (
          scrollTop > 0 &&
          this.lastPage === false &&
          this.searchingForCustomers === false
      ) {
        // TODO: Colocar tratamento para quando não tem mais clientes para buscar
        this.searchingForCustomers = true
        this.$store.dispatch('setShowLoadingOverlay', false)

        this.$store.dispatch("customer/fetch", {
          deleted_at: null,
          concatResults: true,
          search_query: this.searchFilted,
          pagination_page: this.currentPage + 1,
          pagination_limit: this.limitPerPage,
          instance_ids: (this.chosenInstances.map((instance) => { return instance.id }))
        }).then((response) => {
          if (response.data.data.customers.items.length < this.limitPerPage) {
            this.$store.dispatch('setShowLoadingOverlay', true)
            this.searchingForCustomers = false
            this.lastPage = true;
            return;
          }
          // Joga o scroll um pouco para cima
          this.$nextTick(() => {
            this.$refs.newChatScroll.$el.scrollTop = this.$refs.newChatScroll.$el.scrollTop - 120
          })

          this.searchingForCustomers = false
          this.currentPage = this.currentPage + 1

          this.$store.dispatch('setShowLoadingOverlay', true)

        }).catch(() => {
          this.$store.dispatch('setShowLoadingOverlay', true)
          this.searchingForCustomers = false
        })
      }
    },
    async updateActiveChatUser(customer) {
      const cService = new CustomerService()
      const ctService = new ChatTicketService()
      const cachedCustomer = await cService.getById(customer.customer.id)

      if (cachedCustomer.length === 0) {
        await cService.insert({
          id: customer.customer.id,
          name: customer.customer.name,
          is_favorite: customer.customer.is_favorite,
          phone_number: customer.customer.phone_number,
          is_blacklisted: customer.customer.is_blacklisted,
          image: customer.customer.image === null || customer.customer.image === undefined ? '' : customer.customer.image,
          open_field: customer.customer.open_field === null || customer.customer.open_field === undefined ? '' : customer.customer.open_field,
        })
      }

      if (Number(this.limitChatTicketsActivated) && !(this.activeUserInfo.role.name === "administrador" || this.setting > await ctService.getCountChatActive())) {
        return this.$vs.notify({
          color: "danger",
          title: "Limite de atendimentos atingido!",
          text: "Você não pode pegar este atendimento porque o limite de atendimentos simultâneos foi atingido."
        })
      }

      this.activeChat = customer;
      if (this.unifyConnections){ return this.activeChosen = true; }
      if (this.instance.is_official){ return this.openedMessageTemplatePopUp = true; }

      await this.selectActiveChat()
    },
    async selected(listIds){
      this.instanceIds = listIds;

      if (this.activeMultiple) {
        return this.instanceIds
      }

      if (this.instance.is_official) {
        return this.openedMessageTemplatePopUp = true;
      }

      await this.selectActiveChat()
    },
    async selectActiveChat(phoneNumber = null, openByTemplate = null) {
      let updateToCustomer = this.activeChat

      if (phoneNumber || !updateToCustomer.customer.has_valid_phone_number) {
        updateToCustomer.customer = (await customerApi.newAttendanceToCustomer({
          phoneNumber: !phoneNumber ? updateToCustomer.customer.phone_number : phoneNumber,
          instanceId: this.instance.id
        })).data.data.newAttendanceToCustomer
      }

      openByTemplate !== null && (updateToCustomer.open_by_template = openByTemplate);
      updateToCustomer.instance_id = this.instance.id

      if (this.reopenChat) {
        this.$emit('resetActiveChatUser');
      } else {
        this.$emit('updateActiveChatUser', updateToCustomer)
      }

      this.closeCallback();
    },
    closeNewChat() {
      this.closeCallback()
      this.$emit('closeNewChatSidebar')
    },
    closeChosen() {
      this.activeMultiple = false
      this.activeChosen = false
    },
    chooseMutilpe(){
      this.activeMultiple = true
      this.activeChosen = true
    },
    searchCustomer() {
      this.cleanData()
      this.searchQuery = this.searchQuery.replace('+55', '')
      this.$store.dispatch("customer/fetch", {
        deleted_at: null,
        search_query: this.searchFilted,
        pagination_page: this.currentPage,
        pagination_limit: this.limitPerPage,
        instance_ids: (this.chosenInstances.map((instance) => { return instance.id }))
      })
    },
    onEnterSearch() {
      this.searchCustomer()
    },
    searchBlank() {
      if (this.searchQuery === '') {
        this.searchCustomer()
      }
    },
    cleanData(isActive = false){
      if (isActive) { this.searchQuery = '' }
      this.currentPage = 1;
      this.lastPage = false;
      this.$refs.newChatScroll.$el.scrollTop = 0;
    },
    closeCallback() {
      this.instanceIds = []
      this.activeChat = null;
      this.reopenChat = false;
      this.activeChosen = false;
      this.activeMultiple = false
      this.openedMessageTemplatePopUp = false;
    },
  },
  mounted() {
    this.$events.on('closeAllPopUps', this.closeCallback);

    this.$events.off('openMetaMessageTemplate')
    this.$events.on('openMetaMessageTemplate', ({activeChatUser: activeChat, instanceId: instanceId, reopen: reopen = true}) => {
      this.reopenChat = reopen;
      this.activeChat = activeChat;
      this.instanceIds = [instanceId];
      this.openedMessageTemplatePopUp = true;
    })
  },
  beforeDestroy() {
    this.$events.off('closeAllPopUps', this.closeCallback);
  },
  components: {
    ChatContact,
    VuePerfectScrollbar,
    ChosenInstancePopUp,
    MetaMessageTemplatePopUp
  }
}
</script>

<style lang="scss">
#new-chat-sidebar {
  .vs-sidebar--items {
    overflow: auto !important;
  }

  .chat-scroll-area {
    height: calc(100% - 10px) !important;
  }
}
</style>